import React from "react";
import styles from "./Gallery.module.css";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import { CircleArrowLeft, Download } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Ring2 } from "ldrs/react";
import "ldrs/react/Ring2.css";
import { useState } from "react";

const Gallery = ({ image }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const downloadAllImages = async () => {
    const zip = new JSZip();
    setLoading(true);
    for (const imageUrl of image) {
      const response = await fetch(imageUrl);
      const arrayBuffer = await response.arrayBuffer();
      zip.file(imageUrl.substring(imageUrl.lastIndexOf("/") + 1), arrayBuffer);
    }

    zip.generateAsync({ type: "blob" }).then((blob) => {
      saveAs(blob, "images.zip");
    });
    setLoading(false);
  };

  const downloadSingleImage = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const filename = url.substring(url.lastIndexOf("/") + 1);
      saveAs(blob, filename);
    } catch (error) {
      console.error("Failed to download image:", error);
    }
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.arrow} onClick={() => navigate("/")}>
          <CircleArrowLeft size={36} />
        </div>
        <h1 className={styles.heading}>Image Gallery</h1>
      </div>

      {image && image.length > 0 ? (
        <>
          <div className="flex justify-center my-6">
            <button
              className={`px-6 py-3 bg-[#0077b6] text-white text-lg md:text-xl font-semibold rounded-full shadow-md transition-all min-w-54 ${
                loading
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:scale-105 active:scale-95"
              }`}
              onClick={downloadAllImages}
              disabled={loading}
            >
              {loading ? ( // Default values shown
                <div className="flex  justify-center gap-4">
                  <span>Downloading zip</span>
                  <Ring2
                    size="30"
                    stroke="5"
                    strokeLength="0.25"
                    bgOpacity="0.1"
                    speed="0.8"
                    color="white"
                  />
                </div>
              ) : (
                "Download All Images"
              )}
            </button>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6 p-4">
            {image.map((imageUrl, index) => (
              <div
                key={index}
                className="relative shadow-lg rounded overflow-hidden"
              >
                <img
                  src={imageUrl}
                  alt={`Match ${index + 1}`}
                  className="w-full h-auto xs:h-[300px] object-cover"
                />
                <button
                  className="absolute bottom-2 right-2 bg-[#0077b6] text-white p-2 rounded-full shadow transition"
                  onClick={() => downloadSingleImage(imageUrl)}
                  title="Download Image"
                >
                  <Download size={20} />
                </button>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className={styles.noMatch}>
          <h2>No matching faces were detected. Please try again.</h2>
        </div>
      )}
    </>
  );
};

export default Gallery;
